import React from 'react';
import PropTypes from 'prop-types';
import { getImage } from 'gatsby-plugin-image';
import { Text, Link } from '@comicrelief/component-library';

import ImagePropType from '../../commonPropTypes/commonPropTypes';

import {
  Section, Wrapper, Title, Item, Container
} from './PeopleList.styles';

const compare = (a, b) => {
  // Split the full name into array of strings:
  const personAName = a.node.title.toUpperCase().split(' ');
  const personBName = b.node.title.toUpperCase().split(' ');

  // Grab the last part of the name; the surname:
  const surnameA = personAName[personAName.length - 1];
  const surnameB = personBName[personBName.length - 1];

  let comparison = 0;

  // Compare string 'value' of the 2 names:
  if (surnameA > surnameB) {
    comparison = 1;
  } else if (surnameA < surnameB) {
    comparison = -1;
  }
  return comparison;
};

const PeopleList = ({ people }) => {
  const positions = [
    { id: 10, user: 'BOARD OF TRUSTEES', color: 'white' },
    { id: 20, user: 'CEO AND DIRECTORS', color: 'grey_light' },
    { id: 30, user: 'FOUNDER', color: 'white' },
    { id: 40, user: 'LIFE PRESIDENTS', color: 'grey_light' }
  ];

  const team = (user, color) => people.sort(compare).map(({
    node: {
      id, title, role, path, image, type
    }
  }) => {
    const thisImageData = getImage(image);
    const thisImageSrcSet = thisImageData?.images?.sources[0]?.srcSet;
    const thisImageLow = thisImageData?.placeholder?.fallback;
    const thisImageDesc = image?.description ?? '';
    const bgColor = color || 'white';

    return (
      user.toLowerCase().indexOf(type[0].toLowerCase()) > -1 && (
      <Item
        imageLow={thisImageLow}
        image={thisImageSrcSet}
        images={thisImageSrcSet}
        key={id}
        backgroundColor={bgColor}
        imageAltText={thisImageDesc}
      >
        <Text tag="p" weight="bold">
          {role}
        </Text>
        <Text tag="h3" color="deep_violet">
          <Link href={`/meet-the-team/${path}`}>{title}</Link>
        </Text>
      </Item>
      )
    );
  });
  return (
    <Container data-test="meet-the-team-block">
      {positions.map(({ id: index, user, color }) => (
        <Section color={color} key={index}>
          <Title tag="h2" color="deep_violet">
            {/* Update the title dynamically */}
            { user === 'CEO AND DIRECTORS' && Object.values(team(user, color)).filter(Boolean).length < 2 ? 'CEO' : user }
          </Title>
          <Wrapper>{team(user, color)}</Wrapper>
        </Section>
      ))}
    </Container>
  );
};

PeopleList.propTypes = {
  people: PropTypes.arrayOf(
    PropTypes.shape({
      node: PropTypes.shape({
        id: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        role: PropTypes.string.isRequired,
        path: PropTypes.string.isRequired,
        image: ImagePropType.isRequired
      }).isRequired
    })
  ).isRequired
};

export default PeopleList;
